@if (store) {
  <h6>{{ store.address_company }}</h6>
  @for (project of projects; track project) {
    <hawk-icon-expand-bar [description]="project.project_name" [isExpanded]="expandedProjects.includes(project)">
      <div content class="operations_list">
        @for (op of getStoresProjectOperations(project); track op) {
          <div class="store_operation_container">
            <div class="operation_value" style="flex: 1">
              <div style="line-height: 14px; font-size: 12px">
                T:
                @if (op.ticket.id >= 0) {
                  <a href="/a/ticket/{{ op.ticket.id }}?operation_id={{ op.id }}" target="_blank">
                    {{ op.ticket.id }}
                  </a>
                }
                @if (op.ticket.id < 0) {
                  NEU
                }
                <br />
                {{ op.ticket.priority.name }}
                @if (op.ticket.datesla || op.ticket.memos?.length || op.date_fixed) {
                  <div style="display: inline-flex; flex-direction: row">
                    @if (op.ticket.datesla) {
                      <div class="info_marker" [tooltip]="op.slaDateInformation()">
                        <b>SLA!</b>
                      </div>
                    }
                    @if (op.date_fixed) {
                      <div class="info_marker" [tooltip]="'Fixtermin: ' + op.getDateString()">
                        <b>FIX!</b>
                      </div>
                    }
                    @if (op.ticket.memos?.length) {
                      <div class="info_marker" [tooltip]="op.ticket.memos.join(' | ')">
                        <b>Memos!</b>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="operation_value" style="width: 160px" [tooltip]="op.description">
              <div style="line-height: 14px; font-size: 12px">
                {{ op.description.slice(0, 40) }}
                @if (op.description.length > 40) {
                  ...
                }
              </div>
            </div>
            <div style="margin: 0; position: relative">
              @if (op.isUnassigned()) {
                @if (
                  op.isInPlanningProcess() ||
                  (PATourPlannerControl.Instance.tourPlannerExtraOperationCollection.includes(op) &&
                    (!this.technicianDate || this.technicianDate.hasOperationWithIdInChangedTour(op.id)))
                ) {
                  <div
                    class="icon_container"
                    style="padding: 0 2px; background-color: #f44336; color: white; cursor: pointer"
                    (click)="removeOperationFromTourPlanning(op)"
                  >
                    <fa-icon [icon]="faMinus" style="line-height: 10px; font-size: 10px"></fa-icon>
                    <div style="line-height: 9px; font-size: 10px">
                      {{
                        op.calculateOperationTimeMilliseconds({ use_technician: technicianDate?.technician }) / 60000
                      }}min
                    </div>
                  </div>
                } @else {
                  <div
                    class="black_gradient_background icon_container"
                    style="padding: 0 2px"
                    (click)="addOperationToTourPlanning(op)"
                  >
                    <fa-icon [icon]="faPlus" style="height: 14px; line-height: 18px"></fa-icon>
                    <div style="line-height: 9px; font-size: 10px">
                      {{
                        op.calculateOperationTimeMilliseconds({ use_technician: technicianDate?.technician }) / 60000
                      }}min
                    </div>
                  </div>
                }
                @if (technicianDate && !op.checkGeneralTechnicianDoability(technicianDate.technician)) {
                  <div
                    style="
                      position: absolute;
                      top: 0;
                      right: 0;
                      left: 0;
                      bottom: 0;
                      display: inline-flex;
                      background-color: rgba(53, 53, 53, 0.6);
                    "
                    [tooltip]="op.nonFeasibilityReasonsForTechnician(technicianDate.technician).join(' | ')"
                  >
                    <div style="margin: auto; font-size: 1.2rem">&#x274C;</div>
                  </div>
                }
              }
              @if (!op.isUnassigned()) {
                <div
                  class="black_gradient_background_no_hover icon_container"
                  [tooltip]="op.getDateString()"
                  style="padding: 0 6px; display: inline-flex"
                >
                  <fa-icon [icon]="faCalendarCheck"></fa-icon>
                </div>
              }
            </div>
          </div>
        }
      </div>
      <div icon style="margin: auto; display: inline-flex">
        <div
          [style.background-color]="project.color"
          class="project_color_circle"
          style="color: black; display: inline-flex; line-height: 0"
        >
          <div style="margin: auto; line-height: 0"></div>
        </div>
      </div>
    </hawk-icon-expand-bar>
  }
}
